import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IMailingAddress } from "@utils/interfaces";
import { PartialObject } from "lodash";

export interface MyInfoProps {
  salutation?: string | undefined | null;
  firstName?: string | undefined | null;
  lastName?: string | undefined | null;
  fullName: string | undefined | null;
  mobileNum?: string | undefined | null;
  emailId?: string | undefined | null;
  nric: string;
  dateOfBirth: string;
  nationality: string;
  residentialStatus: string;
  gender: string;
  mailingAddress?: IMailingAddress | null;
  stayInTouch?: string | undefined | null;
  colorFlag?: string | undefined | null;
  address: {
    country: string;
    block: string;
    unitNo: string;
    street: string;
    postal: string;
    building: string;
  };
  nationalityCode: string;
  customerId: number | undefined | null;
  age?: number;
}

interface Step4State {
  singpassInitiatedOrManual: "SINGPASS" | "MANUAL" | null;
  selectedChildInfo: MyInfoProps | null;
  availToPurch: Array<MyInfoProps> | null;
  purchThroMyself: Array<MyInfoProps> | null;
  existingCCPPlan: Array<MyInfoProps> | null;
  doesNotQualifProd: Array<MyInfoProps> | null;
  policyAppInProcess: any;
  error: any;
  myInfo: MyInfoProps;
  myinfoTransactionId: string;
  isMyInfoSumbitted: boolean;
  isMailingAddressConfirmed: boolean;
  rentalPostalCustomer: string;
  dobMisMatch: boolean;
}

const initialState: Step4State = {
  singpassInitiatedOrManual: null,
  selectedChildInfo: null,
  error: null,
  availToPurch: null,
  purchThroMyself: null,
  existingCCPPlan: null,
  doesNotQualifProd: null,
  policyAppInProcess: null,
  myInfo: {
    salutation: "",
    firstName: "",
    lastName: "",
    fullName: "",
    mobileNum: "",
    emailId: "",
    nric: "",
    dateOfBirth: "",
    nationality: "",
    residentialStatus: "",
    gender: "",
    mailingAddress: null,
    stayInTouch: null,
    colorFlag: null,
    address: {
      country: "SG",
      block: "",
      unitNo: "",
      street: "",
      postal: "",
      building: "",
    },
    nationalityCode: "",
    customerId: null,
    age: -1,
  },
  myinfoTransactionId: "",
  isMyInfoSumbitted: false,
  isMailingAddressConfirmed: false,
  rentalPostalCustomer: "",
  dobMisMatch: false,
};

const step4Slice = createSlice({
  name: "CancerCover-Step4",
  initialState,
  reducers: {
    updateMyInfoRecord: (state, action: PayloadAction<MyInfoProps | {}>) => {
      state.myInfo = { ...state.myInfo, ...action.payload };
    },
    updateMyChildRecord: (
      state,
      action: PayloadAction<PartialObject<Step4State>>
    ) => {
      if (action.payload.myInfo) state.myInfo = action.payload.myInfo as any;
      state.purchThroMyself = action.payload.purchThroMyself || null;
      state.availToPurch = action.payload.availToPurch || null;
      state.doesNotQualifProd = action.payload.doesNotQualifProd || null;
      state.existingCCPPlan = action.payload.existingCCPPlan || null;
      state.policyAppInProcess = action.payload.policyAppInProcess || null;
    },
    updateErrorMyInfoRecord: (state, action: PayloadAction<any>) => {
      state.error = { ...state.error, ...action.payload };
    },
    updateMyInfoTransactionId: (state, action: PayloadAction<string>) => {
      state.myinfoTransactionId = action.payload;
    },
    updateRentalPostalCustomer: (state, action: PayloadAction<string>) => {
      state.rentalPostalCustomer = action.payload;
    },
    updateIsMyInfoSubmitted: (state, action: PayloadAction<boolean>) => {
      state.isMyInfoSumbitted = action.payload;
    },
    updateChildItem: (state, action: PayloadAction<any>) => {
      const payload = action.payload;
      const personalChildInfo: any = state;
      personalChildInfo[payload.itemType][payload.index] = payload.item;
      state = personalChildInfo;
    },
    updateSelectedChild: (state, action: PayloadAction<MyInfoProps>) => {
      state.selectedChildInfo = action.payload;
    },
    updateSingpassInitiatedOrManual: (
      state,
      action: PayloadAction<"SINGPASS" | "MANUAL" | null>
    ) => {
      state.singpassInitiatedOrManual = action.payload;
    },
    updateToIntialState4: (state, action: PayloadAction<any>) => ({
      ...initialState,
    }),
    updatePartialDataStep4: (state, action:PayloadAction<any>)=>({
      ...state,
      ...action.payload
    }),
    updateIsMailingAddressConfirmed: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isMailingAddressConfirmed = action.payload;
    },
    updateMailingAddressState: (
      state,
      action: PayloadAction<IMailingAddress | null>
    ) => {
      state.myInfo = {
        ...state.myInfo,
        mailingAddress: action.payload,
      };
    },
  },
  extraReducers: {},
});

export const {
  updateSingpassInitiatedOrManual,
  updateToIntialState4,
  updatePartialDataStep4,
  updateChildItem,
  updateSelectedChild,
  updateErrorMyInfoRecord,
  updateMyInfoRecord,
  updateMyInfoTransactionId,
  updateRentalPostalCustomer,
  updateMyChildRecord,
  updateIsMyInfoSubmitted,
  updateIsMailingAddressConfirmed,
  updateMailingAddressState,
} = step4Slice.actions;

export default step4Slice.reducer;
